// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"f024c180","246":"0a069634","257":"56f49d28","282":"44f8f437","456":"0a069634","481":"0a069634","623":"56f49d28","642":"5eb19855","935":"53a305c0","976":"84110782"}[chunkId] + ".chunk.css";
};